import { render, staticRenderFns } from "./BaseWizard.vue?vue&type=template&id=a7b3cd90&"
import script from "./BaseWizard.vue?vue&type=script&lang=js&"
export * from "./BaseWizard.vue?vue&type=script&lang=js&"
import style0 from "./BaseWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports